import Image from "next/image";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Icon } from "@/components/icon";

import { buildFileSrc } from "../../lib/helpers";
import config from "../../common/config";
import styles from "./swiperPreviews.module.scss";

function ProjectVideo({ videoItem, onTogglePlay = () => {} }) {
  const [playVideo, togglePlayVideo] = useState(false);
  useEffect(() => {
    togglePlayVideo(false);
  }, [videoItem]);

  if (!videoItem.link) return null;
  const thumbnail = videoItem.thumbnail
    ? buildFileSrc(
        `projects/${videoItem.thumbnail}`,
        config.IMAGES_CDN_BASE_URL,
      )
    : undefined;

  const getThumbnailCard = () => {
    return (
      <div className={styles.thumbnailCard}>
        <Image
          alt={videoItem.title}
          loader={({ src }) => {
            return src;
          }}
          src={thumbnail}
          unoptimized
          fill
        />
        <Icon
          name="playVideo"
          className={styles.playVideoIcon}
          onClick={() => {
            onTogglePlay();
            togglePlayVideo(true)
          }}
        />
      </div>
    );
  };

  const getVideoCard = () => {
    return (
      <video controls autoPlay src={videoItem.link} width="100%" height="100%">
        <track kind="captions" />
      </video>
    );
  };

  return (
    <div className={styles.projectVideoContainer}>
      {videoItem.thumbnail && !playVideo && getThumbnailCard()}
      {(playVideo || !videoItem.thumbnail) && videoItem.link && getVideoCard()}
    </div>
  );
}

ProjectVideo.propTypes = {
  videoItem: PropTypes.shape({
    link: PropTypes.string,
    thumbnail: PropTypes.string,
  }),
};

ProjectVideo.defaultProps = {
  videoItem: {},
};

export default ProjectVideo;
